module.exports = __webpack_public_path__ + "static/media/camera-about-us.710e83c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/tepual/icons/camera-about-us.svg
// module id = 659
// module chunks = 0